import React, { useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeFilterTag, receive } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const FacetedSearchTags = () => {
    const dispatch = useDispatch();
    const { selectedFilters } = useSelector(
        (state) => state.facetedSearch
    );
    const hasSelectedFilter = selectedFilters && Object.keys(selectedFilters).length > 0 ? true : false;

    // Save selected filters to localStorage whenever they change
    useEffect(() => {
        localStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));
    }, [selectedFilters]);

    // Load selected filters from localStorage when the component mounts
    useEffect(() => {
        const savedFilters = localStorage.getItem('selectedFilters');
        if (savedFilters) {
            dispatch(receive({ selectedFilters: JSON.parse(savedFilters) }));
        }
    }, [dispatch]);

    const handleClearAllFilters = () => {
        const url = new URL(window.location.href);
        const q = url.searchParams.has('q')
            ? `q=${url.searchParams.get('q')}`
            : '';
        dispatch(removeFilterTag(q));
    };

    return (
        <Fragment>
            {hasSelectedFilter &&
                Object.entries(selectedFilters).map(([key, value], index) => (
                    <div key={index} className="product-sorting__selected-filter" onClick={() => dispatch(removeFilterTag(value))}>
                        <span>{key}</span>
                    </div>
                ))
            }
            {hasSelectedFilter &&
                <div className="product-sorting__reset-filter" onClick={handleClearAllFilters}>
                    <span>{translate('code.filters.clear')} <i className="fa-solid fa-trash"></i></span>
                </div>
            }
        </Fragment>
    );
};

export default FacetedSearchTags;